import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewFilterProfileModel } from '../../models';
import { AllocationViewProfilesEndpoint } from './../../constants';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewFilterProfileListService {
  constructor(private http: WrapperHttpService) {}

  getAllocationViewFilterProfiles(): Observable<AllocationViewFilterProfileModel[]> {
    const url = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Filters}${AllocationViewProfilesEndpoint.Profiles}`;
    return this.http.withLoading().get(url);
  }
}
